<template>
  <img src="../../../assets/img/Icons/solar.png" />
</template>

<script>
export default {}
</script>

<style></style>
